import {createBrowserRouter} from 'react-router-dom'

import {ROUTE_NOT_FOUND, ROUTE_OFFER} from '@/routes/routeNames'

export const makeRoutes = () => {
  return createBrowserRouter([
    {
      path: '/',
      lazy: () => import('./root'),
      children: [
        {
          path: ROUTE_OFFER,
          lazy: () => import('./offer'),
        },
      ],
    },
    {
      path: ROUTE_NOT_FOUND,
      lazy: () => import('./not-found'),
    },
  ])
}
